import { PortalDocument } from 'vopay';
import { useEffect, useState } from 'react';
import { SearchBar } from 'UI';
import styles from '../Video/VideoContainer.module.scss';

type PortalGuideFormProps = {
  documents: PortalDocument[];
  filteredByKeyWordLists: { [key: string]: PortalDocument };
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  setFilteredByKeyWordLists: (doc: { [key: string]: PortalDocument }) => void;
  getSelectedDocument: (doc: PortalDocument) => void;
  setHasSearchResult: (e: boolean) => void;
};

export default function PortalGuideForm({
  documents,
  filteredByKeyWordLists,
  searchTerm,
  setSearchTerm,
  setFilteredByKeyWordLists,
  getSelectedDocument,
  setHasSearchResult,
}: PortalGuideFormProps) {
  // The matches dropdown hides after a search or a pick, until the term changes again
  const [isMenuDismissed, setIsMenuDismissed] = useState(false);
  const isMenuVisible = !isMenuDismissed && Object.values(filteredByKeyWordLists || {}).length !== 0;

  useEffect(() => {
    setIsMenuDismissed(false);

    if (searchTerm === '') {
      setFilteredByKeyWordLists({});
    } else {
      const filtered = (documents || [])
        .filter((doc) => doc.title.toLowerCase().includes(searchTerm.toLowerCase()))
        .reduce(
          (accumulator, doc, index) => ({
            ...accumulator,
            [index]: { ...doc },
          }),
          {},
        );

      setFilteredByKeyWordLists(filtered);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === '') {
      setHasSearchResult(false);
    }
  }, [searchTerm]);

  return (
    <SearchBar
      className={styles.searchForm}
      name="docu-search"
      value={searchTerm}
      onChange={setSearchTerm}
      onSearch={() => {
        setHasSearchResult(true);
        setIsMenuDismissed(true);
      }}
    >
      {isMenuVisible && (
        <div className={styles.listContainer} data-testid="learning-centre-matches">
          {Object.values(filteredByKeyWordLists).map((doc, index) => {
            const title = doc.title;
            const lowerSearchTerm = searchTerm.toLowerCase();
            const indexOfMatch = title.toLowerCase().indexOf(lowerSearchTerm);

            if (indexOfMatch !== -1) {
              const beforeMatch = title.substring(0, indexOfMatch);
              const match = title.substring(indexOfMatch, indexOfMatch + lowerSearchTerm.length);
              const afterMatch = title.substring(indexOfMatch + lowerSearchTerm.length);

              return (
                <div
                  key={index}
                  className={styles.selectOption}
                  onClick={() => {
                    getSelectedDocument(doc);
                    setIsMenuDismissed(true);
                  }}
                >
                  {beforeMatch}
                  <strong>{match}</strong>
                  {afterMatch}
                </div>
              );
            } else {
              return (
                <div
                  key={index}
                  className={styles.selectOption}
                  onClick={() => {
                    getSelectedDocument(doc);
                    setIsMenuDismissed(true);
                  }}
                >
                  {title}
                </div>
              );
            }
          })}
        </div>
      )}
    </SearchBar>
  );
}
